import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./IndianTraditionalProducts.css";

export default function IndianTraditionalProducts() {
    const traditionalProducts = [
        {
            id: 1,
            name: "MAKAHNA (FOX NUTS)",
            image: "/assets/img/Indian Traditional Products/Makhana-Fox-Nuts.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Healthy snack foods",
                        "Diet snacks",
                        "Roasted snacks",
                        "Breakfast bowls",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Low in calories",
                        "High in protein",
                        "Rich in antioxidants",
                        "Gluten-free superfood",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "DRY COCONUT",
            image: "/assets/img/Indian Traditional Products/Dry-Coconut.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Indian sweets",
                        "Bakery products",
                        "Cooking ingredient",
                        "Snack mixes",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich coconut flavor",
                        "High energy food",
                        "Long shelf life",
                        "Widely used in cuisine",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "COCONUT CHIPS",
            image: "/assets/img/Indian Traditional Products/Coconut-Chips.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Snacks",
                        "Granola mixes",
                        "Bakery toppings",
                        "Desserts",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Crunchy texture",
                        "Natural sweetness",
                        "Healthy fat source",
                        "Popular snack ingredient",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "BETEL NUT (SUPARI)",
            image: "/assets/img/Indian Traditional Products/Betel-Nut-Supari.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Traditional chewing products",
                        "Cultural uses",
                        "Ayurvedic preparations",
                        "Food flavoring",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Cultural importance",
                        "Distinct flavor",
                        "Widely consumed in Asia",
                        "Traditional ingredient",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Indian Traditional Products"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Indian Traditional Products</h1>

                    <p className="pp-subtitle">
                        Explore our premium range of authentic Indian traditional food
                        products sourced from trusted suppliers.
                    </p>

                    <div className="pp-grid">
                        {traditionalProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}